import * as React from 'react';
import './Box.less';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import SVGComponent from '../common/SVGComponent';
import { Planet } from "src/constants/Planets";
import { Grade } from "src/constants/Grades";
import { Translate } from 'react-localize-redux';

// interface InfoBoxProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
interface InfoBoxProps {
    currentPlanet: Planet;
    currentGrade: Grade;
    rewards?: string[];
}

interface InfoBoxState {
}

class InfoBox extends React.Component<InfoBoxProps, InfoBoxState> {
    constructor(props: InfoBoxProps) {
        super(props);
        bindAllOfThis(this, InfoBox.prototype);

        // You are allowed to set defaults here, based on your state object above
        this.state = {
        };
    }

    renderRewards() {
        if (this.props.rewards == null || this.props.rewards.length === 0) {
            return;
        }
        return [
            <h3><em key="rewardsLabel">Rewards:</em></h3>,
            this.props.rewards.map((reward, index) => (
                <SVGComponent
                    key={reward + index}
                    path={reward}
                    height="50px"
                    width="50px"
                />
            ))
        ];
    }

    renderCurrentPlanet() {
        if (this.props.currentPlanet != null) {
            return <h3><em key="currentPlanetLabel"><Translate id="common.currentPlanet" />:</em> {this.props.currentPlanet.name}</h3>;
        }
        return null;
    }

    renderShipName() {
        if (this.props.currentGrade != null) {
            return <h3><em><Translate id="common.shipName" />:</em> {`${this.props.currentGrade.commander} 1`}</h3>;
        }
        return null;
    }

    render() {
        let className = `box-component planet-${(this.props.currentPlanet || { name: "" }).name}`.toLowerCase();

        return <div id={"infoBox"} className={className}>
            <span className="info">
                {this.renderShipName()}
                {this.renderCurrentPlanet()}
                {this.renderRewards()}
            </span>
        </div>;
    }
}

export default InfoBox;



// WEBPACK FOOTER //
// ./src/components/mission/InfoBox.tsx